import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore'
import { firebaseDb } from './init'
import {
  IOcrCacheExampaperBase,
  IOcrCacheExampaperPage,
  IOcrCacheExampaperPageBase,
  IOcrCacheExampaperPageRaw,
  IOcrCacheExampaperRaw,
} from '../types/firebase/ocr-cache-ep'

export const OCR_CACHE_EXAM_PAPERS_COLLECTION = 'ocrCacheExamPapers'
const PAGES_SUBCOLLECTION = 'pages'

/**
 * Gets the root Exam Paper cache document.
 */
export async function getExampaperCacheDoc(
  id: string,
): Promise<IOcrCacheExampaperRaw | null> {
  const docRef = doc(firebaseDb, OCR_CACHE_EXAM_PAPERS_COLLECTION, id)
  const docSnap = await getDoc(docRef)

  if (docSnap.exists()) {
    return docSnap.data() as IOcrCacheExampaperRaw
  }
  return null
}

/**
 * Creates the root Exam Paper cache document if it doesn't exist.
 */
export async function createExampaperCacheDoc(
  id: string,
  dto: IOcrCacheExampaperBase,
): Promise<void> {
  const docRef = doc(firebaseDb, OCR_CACHE_EXAM_PAPERS_COLLECTION, id)
  await setDoc(docRef, {
    ...dto,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  })
}

/**
 * Gets cached OCR result for a specific page of an Exam Paper.
 */
export async function getCachedExampaperPage(
  paperId: string,
  pageNumber: number,
): Promise<IOcrCacheExampaperPage | null> {
  const pageDocId = `page_${pageNumber}`
  const docRef = doc(
    firebaseDb,
    OCR_CACHE_EXAM_PAPERS_COLLECTION,
    paperId,
    PAGES_SUBCOLLECTION,
    pageDocId,
  )
  const docSnap = await getDoc(docRef)

  if (docSnap.exists()) {
    return { id: docSnap.id, ...(docSnap.data() as IOcrCacheExampaperPageRaw) }
  }
  return null
}

/**
 * Saves OCR result for a specific page of an Exam Paper.
 */
export async function saveExampaperPage(
  paperId: string,
  dto: IOcrCacheExampaperPageBase,
): Promise<void> {
  const pageDocId = `page_${dto.pageNumber}`
  const docRef = doc(
    firebaseDb,
    OCR_CACHE_EXAM_PAPERS_COLLECTION,
    paperId,
    PAGES_SUBCOLLECTION,
    pageDocId,
  )
  await setDoc(docRef, {
    ...dto,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  })
}
